import { useMemo } from 'react';
import styles from './styles.module.scss';
import Dropdown from '@/components/dropdown';
import { lobFormModes } from '@certificate_hero/enums';

/**
 * Acord23Schedules renders a single-select dropdown that allows users to pick
 * one AMS schedule. The selected schedule populates the LOB form's coverage
 * fields directly.
 */
const Acord23Schedules = ({
  amsSchedules,
  currentMode,
  selectedScheduleId,
  onScheduleSelect,
}) => {
  const scheduleOptions = useMemo(
    () => [
      { text: 'None', value: '' },
      ...amsSchedules.map(s => ({ text: s.name, value: s.amsId })),
    ],
    [amsSchedules]
  );

  const handleScheduleSelect = option => onScheduleSelect(option.value || '');

  return (
    <Dropdown
      className={styles.schedulesDropDown}
      name="schedulesDropDown"
      label="Schedule"
      placeholder="SELECT SCHEDULE"
      options={scheduleOptions}
      disabled={currentMode !== lobFormModes.MANAGER}
      value={selectedScheduleId}
      onChange={handleScheduleSelect}
      optionEllipsisCutoffLength={100}
    />
  );
};

export default Acord23Schedules;
